import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, FormattedMessage } from 'react-intl';

import BasicDataPod from '../../../components/BasicDataPod';
import Value from '../../../components/BasicDataPod/Value';
import Link from '../../../components/BasicDataPod/Link';
import { calculateDistance } from '../../../utils/calculate';
import { getGoogleMapUrl } from '../../../utils/url';
import './styles.css';

const messages = defineMessages({
  title: {
    id: 'hubs.student-life.distance-from-hs.title',
    defaultMessage: 'Distance From Your High School',
  },
  linkText: {
    id: 'hubs.student-life.distance-from-hs.link-text',
    defaultMessage: 'Get Directions',
  },
  subText: {
    id: 'hubs.student-life.distance-from-hs.subText',
    defaultMessage: 'Miles',
  },
});

const DistanceFromHS = ({ highSchool, college, intl }) => {
  const value = calculateDistance(highSchool, college);
  const googleMapUrl = getGoogleMapUrl(college.latitude, college.longitude);
  const title = intl.formatMessage(messages.title);

  return value ? (
    <BasicDataPod
      header={title}
      ariaLabel={`${title}, ${value} ${intl.formatMessage(messages.subText)}`}
    >
      <div className="distance-from-hs-pod-value-container">
        <Value value={value} className="no-margin" />
        <p className="distance-from-hs-subtext">
          <FormattedMessage {...messages.subText} />
        </p>
      </div>
      <Link
        linkText={intl.formatMessage(messages.linkText)}
        linkUrl={googleMapUrl}
        external
      />
    </BasicDataPod>
  ) : null;
};

DistanceFromHS.propTypes = {
  highSchool: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
  college: PropTypes.shape({
    latitude: PropTypes.number,
    longitude: PropTypes.number,
  }),
};

DistanceFromHS.defaultProps = {
  highSchool: {},
  college: {},
};

export default injectIntl(DistanceFromHS);
